import styles from './ModalConfirmRegister.module.css';
import Modal from 'react-responsive-modal';
import { Button } from '../../../../components/Button';
import { Link } from 'react-router-dom';
import * as routes from '../../../../constants/Routes';

interface IModalFinishRegisterPorteiro {
  modalIsOpen: boolean;
  player: any;
  toggleModal: () => void;
}
export function ModalFinishRegisterPorteiro({
  modalIsOpen,
  player,
  toggleModal,
}: IModalFinishRegisterPorteiro) {
  return (
    <Modal
      open={modalIsOpen}
      onClose={toggleModal}
      center
      closeOnOverlayClick={false}
      closeIcon={false}
      closeOnEsc={false}
    >
      <div className="contents-modal">
        <div className="d-flex justify-content-center">
          <img
            className={`mb-4 ${styles.alert}`}
            src="https://cdn-icons-png.flaticon.com/512/11312/11312124.png"
            alt=""
          />
        </div>
        <h1 className="title-modal">Parabéns, {player && player.name}!</h1>
        <p className="subtitle-modal">Você ganhou R$ 50,00</p>
      </div>
      <div className={styles.contentBtn}>
        <Link to={routes.REDEEM_AWARDS} className="w-100">
          <Button
            isModal
            text="Resgatar prêmio"
            type="button"
            color="primary"
            onClick={toggleModal}
          />
        </Link>
      </div>
    </Modal>
  );
}
